import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "utils/base-query";

export const planApi = createApi({
    reducerPath: "planApi",
    tagTypes: ["Plan"],
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getAllPlans: builder.query({
            query: (params) => {
                return {
                    method: "GET",
                    url: "/partner-plan/get-plans",
                    params: params
                }
            },
        }),
        getPlanById: builder.query({
            query: (id) => {
                return {
                    method: "GET",
                    url: `/partner-plan/get-plan/${id}`,
                }
            },
        }),
        addPlan: builder.mutation({
            query: (data) => {
                return {
                    method: "POST",
                    url: "/partner-plan/add-plan",
                    body: data,
                }
            },
        }),
        updatePlan: builder.mutation({
            query: ({ id, ...body }) => {
                return {
                    method: "PUT",
                    url: `/partner-plan/update-plan/${id}`,
                    body,
                }
            },
        }),
        deletePlan: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `/partner-plan/delete-plan/${id}`,
            }),
        }),
    }),
});

export const {
    useGetAllPlansQuery,
    useGetPlanByIdQuery,
    useAddPlanMutation,
    useUpdatePlanMutation,
    useDeletePlanMutation,
} = planApi;
